export default __webpack_public_path__ + "static/media/carousel-next.15411615.svg";